import { UNITS } from "./units";
import { AVERAGE_UNITS } from "./average-units";
import { TOTAL_COST } from "./total-cost";
import { TOTAL_RETAIL } from "./total-retail";
import { STORE_WITH_UNITS } from "./store-with-units";
import { PLAN_ROWS } from "./plan-rows";
import { IMU_PERCENTAGE } from "./imu-percentage";
import { UNIT_ROW_PERCENTAGE_PLAN } from "./unit-row-percentage-plan";
import { ROW_PERCENTAGE_PLAN } from "./row-percentage-plan";
import { BREADTH_PERCENTAGE_PLAN } from "./breadth-percentage-plan";
import { UNIT_DOOR_PERCENTAGE_PLAN } from "./unit-door-percentage-plan";
import { DOOR_PERCENTAGE_PLAN } from "./door-percentage-plan";
import { AUR } from "./aur";
import { IMetricsGetterFactoryOptions } from "../getter-setter-factory";
import { ValueGetterParams } from "ag-grid-community";
import { AVERAGE_DEPTH } from "./average-depth";
import { AVERAGE_COST } from "./average-cost";

export const metricsColumnGroupFormulas = {
    UNITS,
    AVERAGE_UNITS,
    STORE_WITH_UNITS,
    TOTAL_COST,
    TOTAL_RETAIL,
    PLAN_ROWS,
    IMU_PERCENTAGE,
    AUR,
    UNIT_ROW_PERCENTAGE_PLAN,
    ROW_PERCENTAGE_PLAN,
    UNIT_DOOR_PERCENTAGE_PLAN,
    DOOR_PERCENTAGE_PLAN,
    BREADTH_PERCENTAGE_PLAN,
    AVERAGE_DEPTH,
    AVERAGE_COST,
};

export const computeColumnFormula = (
    values: number[],
    factoryOptions: IMetricsGetterFactoryOptions,
    gridGetterParams: ValueGetterParams
) => {
    const { kind: metricKind } = factoryOptions.metric;

    const defaultOptions = {
        decimal: 1,
    };

    const mergedOptions = {
        ...defaultOptions,
        ...factoryOptions,
    };

    const formula = metricsColumnGroupFormulas[metricKind as string];

    if (!formula) {
        // eslint-disable-next-line no-console
        console.error(`Metric column formula - ${metricKind} is not valid metric`);
        return 0;
    }

    const computedValue = formula(values, mergedOptions, gridGetterParams);
    return computedValue;
};
